import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ComponentInfoActions } from './component-info.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { ComponentInfoService } from '@ipensii/shared/data-access-shared';

export class ComponentInfoEffects {
  private readonly actions$ = inject(Actions);
  private readonly componentInfoService = inject(ComponentInfoService);

  //noinspection JSUnusedLocalSymbols
  private readonly loadComponentInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ComponentInfoActions.loadComponentInfo),
      switchMap(() =>
        this.componentInfoService.findOne().pipe(
          map((componentInfo) => ComponentInfoActions.loadComponentInfoSuccess({ componentInfo })),
          catchError((error) => of(ComponentInfoActions.loadComponentInfoError({ error })))
        )
      )
    )
  );
}
